import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60 - 1); // 23:59:59
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-3 my-4" data-id="element-84">
      <div className="flex flex-col items-center" data-id="element-85">
        <div className="bg-navy-3 border border-brand-blue-dark text-white font-black text-2xl md:text-3xl py-3 px-4 rounded-lg min-w-[64px] text-center shadow-inner" data-id="element-86">
          {format(hours)}
        </div>
        <span className="text-[11px] text-brand-gray mt-1.5 font-bold tracking-wider uppercase" data-id="element-87">
          Horas
        </span>
      </div>
      <span className="text-2xl font-black text-brand-blue-dark pb-6" data-id="element-88">:</span>
      <div className="flex flex-col items-center" data-id="element-89">
        <div className="bg-navy-3 border border-brand-blue-dark text-white font-black text-2xl md:text-3xl py-3 px-4 rounded-lg min-w-[64px] text-center shadow-inner" data-id="element-90">
          {format(minutes)}
        </div>
        <span className="text-[11px] text-brand-gray mt-1.5 font-bold tracking-wider uppercase" data-id="element-91">
          Min
        </span>
      </div>
      <span className="text-2xl font-black text-brand-blue-dark pb-6" data-id="element-92">:</span>
      <div className="flex flex-col items-center" data-id="element-93">
        <div className="bg-navy-3 border border-brand-blue-dark text-white font-black text-2xl md:text-3xl py-3 px-4 rounded-lg min-w-[64px] text-center shadow-inner" data-id="element-94">
          {format(seconds)}
        </div>
        <span className="text-[11px] text-brand-gray mt-1.5 font-bold tracking-wider uppercase" data-id="element-95">
          Seg
        </span>
      </div>
    </div>;
}